export default {
    accept_payment: "Төлемді қабылдау",
    add_new_record: "+ Келуді қосу",
    added: "Қостым",
    additionally: "Қосымша",
    are_you_sure_want_to_change_time: "Келу уақытын шынымен өзгерте аласыз ба?",
    are_you_sure_want_to_move_visit: " Келуді жылжытқыңыз келе ме?",
    are_you_sure_you_want_to_delete_record: "Шынымен жазбаны жойғыңыз келе ме?",
    blocked: "Бұғатталды",
    by_phone_found: "Телефон нөмірі бойынша {phone} келесі пациенттер табылды",
    by_phone_nobody_found: "Телефон нөмірі бойынша {phone} бірде-бір пациент табылмады",
    calendar_settings: "Күнтізбені реттеу",
    cancel_record: "Жазбаны дою",
    CHAIR: "Кресло бойынша",
    change_record: "Жазбаны өзгерту",
    checkup: "Тексеру",
    child_age: "18 жастан жас",
    choose_all: "Барлығын таңдау",
    clear: "Тазалау",
    confirm_visit: "Келуді растау",
    create_notification: "хабарлама құру",
    create_patient: "Пациентті құру",
    create_task: "Тапсырма құру",
    curation: "Курация",
    DAY: "Бір күнге",
    day_short: "күн",
    days: "күндер",
    delete_record: "Келуді жою",
    diagnostics: "Диагностика",
    DOCTOR: "Дәрігерлер бойынша",
    doctor_available_time: "Дәрігердің қолжетімді уақыты",
    doctor_has_no_available_time_at_this_day: "Дәрігердің бұл күні бос уақыты жоқ",
    doctor_is_not_working_on_this_date_continue: "Дәрігер бұл уақытта жұмыс істемейді немесе бос емес. Жалғастыру керек пе?",
    doctors_selected: "Дәрігерлер таңдалды",
    edit_schedule: "Кестені өңдеу",
    edit_visit: "Келуді өңдеу",
    email_text: "Хаттың мәтіні",
    email_topic: "Хаттың тақырыбы",
    employees_selected: "Қызметкерлер таңдалды",
    fill_treatment: "Емдеуді толтыру",
    fillDoctorColor: "Жазуды дәрігердің түсімен бояу",
    for: "Бұрын",
    free_minutes: "Бос минут",
    hideChairsWithoutSchedule: "Таңдалған күні жұмыс кестесі бар дәрігерсіз креслоларды жасыру",
    hideDoctorsWithoutSchedule: "Таңдалған күні жұмыс істемейтін дәрігерлерді жасыру",
    hour_short: "бастап",
    in_calendar_card_show_first: "Күнтізбе карточкасында бірінші болып көрсету",
    info: "Ақпарат",
    load_demo_data_to_account: "Демо деректерді тіркелгіге жүктеу керек пе?",
    min_short: "мин",
    min_shortest: "м",
    MONTH: "Айға",
    move_record: "Жазбаны ауыстыру",
    need_to_select_at_least_one_doctor: "Ең болмағанда бір дәрігерді таңдау қажет",
    need_to_select_at_least_one_employee: "Ең болмағанда бір қызметкерді таңдау қажет",
    new_visit: "Жаңа келу",
    no_birthdays_on_this_date: "Көрсетілген күнге туған күні жоқ",
    no_free_time: "Бос уақыт жоқ",
    no_schedule: "Кесте жоқ",
    no_visits: "Келулер жоқ",
    not_working: "Жұмыс істемейді",
    of_day: "күн",
    online_consultation: "Онлайн консультация",
    patient_came: "Пациент келді",
    patient_card: "Пациенттің карточкасы",
    patient_comment: "Пациенттің пікірі",
    patient_notifications: "Пациентке хабарламалар",
    postponed: "Ауыстыру",
    quick_view: "Жылдам қарау",
    record_again: "Қайта жазу",
    record_comment: "Пікірге кіріңіз",
    record_conflict: "Жазылуда түсініспеушіліктер",
    record_has_no_paid_services: "Жазылуда ақылы қызметтер жоқ",
    record_type: "Жазылу түрі",
    related_tasks: "Байланысты тапсырмалар",
    requires_confirmation: "Растауды қажет етеді",
    return_visit: "Қайта келу",
    sanation: "Санация",
    schedule: "Кесте",
    select_a_doctor: "Дәрігерді таңдаңыз",
    select_an_employee: "Қызметкерді таңдаңыз",
    select_assistant: "Көмекшіні таңдаңыз",
    selected: "Таңдалды",
    send_sms: "SMS жіберу",
    showClientTags: "Пациенттердің белгілерінің түсін пайдалану",
    showDoctorColor: "Дәрігерлердің түстерін пайдалану",
    showOverflowScreen: "Үлкен деректер жиынында экранды жылжытуды пайдалану",
    showPlannedServices: "Мәтінмен қызметтерді көрсету",
    showRecordTagColor: "Келу фоны ретінде ұяшықтардың түсін қолдану",
    showServiceColor: "Қызмет санаттарының түстерін пайдалану",
    showStatusColor: "Келу статусының түсін пайдалану",
    sms_text: "SMS мәтіні",
    till: "дейін",
    time_has_already_passed: "Уақыт өтіп кетті",
    to_contact: "Байланыс",
    tomorrow: "Ертең",
    visits_count: "Келулер | келу | келу жоқ",
    visits_count_much: "келулер",
    warranty_case: "Кепілдік жағдай",
    WEEK: "Аптаға",
    write: "Жазыңыз",
    write_reason_for_cancellation: "Жою себебін көрсетіңіз",
    yesterday: "Кеше",
    you_have_no_doctors: "Сіздерде бірде-бір дәрігер жоқ. Дәрігерді қосуға болады <a href='{href}'>осы жерде</a>"
}
